import { render, staticRenderFns } from "./Approved.vue?vue&type=template&id=0686a869&scoped=true"
import script from "./Approved.vue?vue&type=script&lang=js"
export * from "./Approved.vue?vue&type=script&lang=js"
import style0 from "./Approved.vue?vue&type=style&index=0&id=0686a869&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0686a869",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0686a869')) {
      api.createRecord('0686a869', component.options)
    } else {
      api.reload('0686a869', component.options)
    }
    module.hot.accept("./Approved.vue?vue&type=template&id=0686a869&scoped=true", function () {
      api.rerender('0686a869', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/prepayments/Approved.vue"
export default component.exports